/* global axios */
import ApiClient from '../ApiClient';

// SiteUp (Onda C): agendas de atendimento do Captain (Captain::AssistantSchedule).
// Uma agenda por funil — grade de horários (business_hours), duração do slot,
// timezone e bloqueio de double-booking. Usadas pela tool schedule_appointment.
// CRUD aninhado em /api/v1/accounts/:account_id/captain/assistants/:assistantId/assistant_schedules.
// O backend espera o corpo { assistant_schedule: { ...campos... } }.
class CaptainAssistantSchedules extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/assistant_schedules`);
  }

  create({ assistantId, ...data } = {}) {
    return axios.post(`${this.url}/${assistantId}/assistant_schedules`, {
      assistant_schedule: data,
    });
  }

  update({ assistantId, id, ...data } = {}) {
    return axios.put(
      `${this.url}/${assistantId}/assistant_schedules/${id}`,
      { assistant_schedule: data }
    );
  }

  delete({ assistantId, id } = {}) {
    return axios.delete(`${this.url}/${assistantId}/assistant_schedules/${id}`);
  }
}

export default new CaptainAssistantSchedules();
